// extracted by mini-css-extract-plugin
export default {"colorTitle":"FormText_colorTitle__kZ9dr","colorDescription":"FormText_colorDescription__I7DGK"};